<template>
    <div class="bg-white">
        <Flash v-if="flashMessage" alert="danger">{{ flashMessage }}</Flash>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
                <h1 class="h4 mb-0">Select a practice</h1>
            </div>
        </div>
        <div class="bg-light p-3">
            <div class="row">
                <div class="col-md-6 col-xxl-3 mb-3">
                    <TextInput
                        label="Practice name"
                        v-model="name"
                        :v="v$.name"
                    />
                </div>
            </div>
        </div>
        <br />
        <ul v-if="filteredPractices.length" class="practice-list mb-4">
            <li v-for="practice of filteredPractices" v-bind:key="practice.id">
                <div class="row align-items-center">
                    <div class="col">
                        <div class="">{{ practice.company_name }}</div>
                    </div>
                    <div class="col d-flex justify-content-end">
                        <div class="">
                            <button class="btn btn-sm btn-secondary" @click="setPractice(practice)">Select</button>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <div v-if="practiceData && !filteredPractices.length">
            No practices
        </div>
    </div>
</template>

<style scoped lang="scss">
    .practice-list
    {
        list-style: none;
        padding: 0px;
        margin: 0px;

        > li
        {
            border-top: 1px solid #EEEEEE;
            padding: 10px 0px;

            strong
            {
                color: $swift-dark-grey;
            }
        }
    }
</style>

<script>
    import api from "@/services/api";
    import useVuelidate from '@vuelidate/core';
    import TextInput from '@/components/TextInput.vue';
    import Flash from '@/components/Flash.vue';

    export default {
        setup () {
            return {
                v$: useVuelidate()
            }
        },
        components: {
            TextInput,
            Flash,
        },
        validations () {
            return {
                name: { },
            }
        },
        data() {
            return {
                practiceData: null,
                name: '',
            }
        },
        computed: {
            currentPage () {
                var pageParam = this.$route.query.page;
                return typeof pageParam === 'undefined' ? 1 : parseInt(pageParam);
            },
            flashMessage () {
                const messages = {
                    403: 'You do not have access to that order.',
                    404: 'Order not found.',
                };
                return messages[this.$route.query.error] || '';
            },
            lastPage () {
                if(this.practiceData !== null && this.practiceData.meta)
                {
                    return parseInt(this.practiceData.meta.last_page);
                }
                return null;
            },
            filteredPractices () {
                if(!this.practiceData)
                {
                    return [];
                }

                var search = this.name.trim().toLowerCase();

                if(!search.length)
                {
                    return this.practiceData.data;
                }

                return this.practiceData.data.filter((practice) => {
                    return practice.company_name && practice.company_name.toLowerCase().includes(search);
                });
            },
        },
        methods: {
            fetchPractices: function() {
                api
                .get('/api/v1/practices')
                .then(response => {
                    this.practiceData = response.data;
                })
                .catch(() => {
                    console.log('Catch practice error');
                });
            },
            setPractice: function(practice) {
                this.$store.dispatch('setCurrentPracticeId', practice.id);
                this.$store.dispatch('setCurrentPractice');
                this.$store.dispatch('setCurrentAccountId');
                this.$router.push(this.$route.query.redirect || '/');
            },
        },
        mounted () {
            this.fetchPractices();
        },
    }

</script>
